<template>
  <el-form
      ref="form"
      :model="form"
      style="height: 100%"
      >
    <template v-if="addOpType || editOpType">
      <gj-area-title
          style="margin-bottom: 10px;"
      >产品明细</gj-area-title>
      <div style="margin-bottom: 10px;">
        <gj-button
            type="primary"
            @click="addProduct"
        >添加产品</gj-button>
        <gj-button
            @click="importProduct"
        >导入产品</gj-button>
        <span v-if="addOpType"
              style="margin: 0 8px; font-size: 12px;">
          绑定货件
          <gj-help popper-class="help_tip">调拨到FBA仓需审批通过后才能绑定货件</gj-help>
        </span>
      </div>
    </template>
    <gj-table
        :index="false"
        adaptParent
        name="transferOrderAddProduct"
        :data="form.items"
        :columns="columns"
        border
        :auto-resize="false"
        :adapt-height-listen-update="false"
        :show-overflow="false"
        :scroll-y="{ enabled: false }"
        :min-height="398"
        :offset-height="offsetHeight">
      <template v-slot:sku="{row}">
        <div>
          <gj-text class="content">{{row.productName | defaultShow}}</gj-text>
        </div>
        <div>{{row.sku | defaultShow}}</div>
        <div>{{row.productType | optionText(productTypeOption)}} - {{row.categoryName | defaultShow}}</div>
      </template>
      <template v-slot:msku="{row}">
        <div>{{row.msku | defaultShow}}</div>
        <div>{{row.fnsku | defaultShow}}</div>
        <div>{{row.asin | defaultShow}}</div>
      </template>
      <template v-slot:quantity="{index}">
        <el-form-item
            :prop="`items.${index}.quantity`"
            :rules="[
              { required: true, message: '请输入调拨量', trigger: ['change'] },
              $gjReRule(RE.pt, '请输入正整数')
            ]"
            class="gj-table-item">
          <gj-input
              v-model="form.items[index].quantity"
              @input="quantityInput(form.items[index])"
              width="100px">
          </gj-input>
        </el-form-item>
      </template>
      <template v-slot:pickQuantity="{index}">
        <el-form-item
            :prop="`items.${index}.pickQuantity`"
            :rules="[
              { required: true, message: '请输入拣货量', trigger: ['change'] },
              $gjReRule(RE.pt, '请输入正整数')
            ]"
            class="gj-table-item">
          <gj-input
              v-model="form.items[index].pickQuantity"
              width="100px">
          </gj-input>
        </el-form-item>
      </template>
      <template v-slot:shipmentId="{row}">
        <template v-if="row.shipmentIdList && row.shipmentIdList.length > 0">
          <div v-for="(shipmentId, i) in row.shipmentIdList"
               :key="i">{{shipmentId}}</div>
        </template>
        <template v-else>-</template>
      </template>
      <template v-slot:deliveryCode="{row}">
        <template v-if="row.relevanceShipNoteList && row.relevanceShipNoteList.length > 0">
          <div v-for="(rlCode, i) in row.relevanceShipNoteList"
               :key="i">
            <gj-popover-panel
                :width="'150px'"
                :data="[
                  `实际出运日期：${rlCode.actualShipDate || '-'}`
                ]">
              {{rlCode.shipNoteCode | defaultShow}}
            </gj-popover-panel>
          </div>
        </template>
        <template v-else>-</template>
      </template>
      <template v-slot:memo="{index}">
        <el-form-item
            :prop="`items.${index}.memo`"
            class="gj-table-item">
          <gj-input
              v-model="form.items[index].memo"
              width="280px"
              placeholder="备注">
          </gj-input>
        </el-form-item>
      </template>
      <template v-slot:op="{index}">
        <gj-button
            type="text"
            @click="deleteItem(index)">
          删除
        </gj-button>
      </template>
      <template #footer>
        <div v-gutter="20" class="default">
          <span>商品种类数：{{form.items.length}}</span>
          <span>调拨量合计：{{form.items | sum('quantity')}}</span>
          <span>总实物重(g)：{{form.items | sum('totalPackageWeight')}}</span>
          <span>总体积(CBM)：{{form.items | sum('totalVolume')}}</span>
        </div>
      </template>
    </gj-table>
  </el-form>
</template>

<script>
  import {OpEnum, ProductEnum} from "@/utils/options";
  import AppAddProductModal from "./add-product-modal";
  import AppImportProductModal from "./import-product-modal";
  import {formDeleteItemMixin, formRuleMixin, opTypeMixin, responseMixin} from "@/minxins";
  import {isMeaningful, isMeaningless, toFixed, unique} from "@/utils/common";
  import {TransferOrderEnum} from "../../../../enum";

  export default {
    name: "app-op-transfer-order-product",
    mixins: [formRuleMixin, responseMixin, formDeleteItemMixin, opTypeMixin],
    props: {
      form: {
        required: true
      },
      opType: {
        required: true
      },
      mountTo: {
        required: true
      },
      transferOrder: {
        required: true
      }
    },
    data() {
      return {
        columns: [],
        OpEnum: OpEnum,
        productTypeOption: ProductEnum.typeOption
      }
    },
    created() {
      this.initColumns();
      if(isMeaningful(this.form.items)){
        this.form.items.forEach(r=>{
          this.quantityInput(r)
        })
      }
    },
    computed: {
      uniKey() {
        return this.form.arrivalMarketId === '0' ? 'sku' : 'msku';
      },
      offsetHeight() {
        if (this.viewOpType) {
          return 208;
        } else if (this.addOpType) {
          return 58;
        } else {
          return 170;
        }
      }
    },
    watch: {
      'form.picking': {
        handler: function(picking) {
          if (picking) {
            this.initViewColumns(true);
          }
        }
      }
    },
    methods: {
      initColumns() {
        if (this.addOpType || this.editOpType) {
          this.columns = [
            {id: 'picture', header: '图片', field: 'picture:skuImageUrl', width: '60px'},
            {id: 'sku', header: '产品名称/SKU/产品类型-品类', field: 'slot:sku', minWidth: '250px'},
            {id: 'msku', header: 'MSKU/FNSKU/ASIN', field: 'slot:msku', minWidth: '200px'},
            {id: 'availableQuantity', header: '现库存可用量', field: 'availableQuantity', width: '100px', align: 'right'},
            {id: 'singleQuantity', header: '单箱数量', field: 'singleQuantity', width: '70px', align: 'right'},
            {id: 'packageWeight', header: '单品实物重(g)', field: 'packageWeight', width: '110px', align: 'right'},
            {id: 'volume', header: '单品体积(CBM)', field: 'volume', width: '115px', align: 'right'},
            {id: 'maxQuantityShipped', header: '建议最大申报量', field: 'maxQuantityShipped',
              help: '此数据来源于亚马逊后台【补货】报表中的“最大发货量”数值', width: '130px', align: 'right'},
            {id: 'quantity', header: '调拨量', field: 'slot:quantity', width: '120px'},
            {id: 'totalPackageWeight', header: '总实物重(g)', field: 'totalPackageWeight', width: '100px', align: 'right'},
            {id: 'totalVolume', header: '总体积(CBM)', field: 'totalVolume', width: '100px', align: 'right'},
            {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '300px'},
            {id: 'op', header: '操作', field: 'slot:op', width: '50px'},
          ]
        }
        if (this.viewOpType) {
          this.initViewColumns(false);
        }
      },
      initViewColumns(pick) {
        const showRlInfo = !(this.transferOrder.status === TransferOrderEnum.status.DRAFT
          || this.transferOrder.status === TransferOrderEnum.status.WAIT_REVIEW);
        this.columns = [
          {id: 'picture', header: '图片', field: 'picture:skuImageUrl', width: '60px'},
          {id: 'sku', header: '产品名称/SKU/产品类型-品类', field: 'slot:sku', minWidth: '250px'},
          {id: 'msku', header: 'MSKU/FNSKU/ASIN', field: 'slot:msku', minWidth: '200px'},
          {id: 'availableQuantity', header: '现库存可用量', field: 'availableQuantity', width: '100px', align: 'right'},
          {id: 'singleQuantity', header: '单箱数量', field: 'singleQuantity', width: '70px', align: 'right'},
          {id: 'packageWeight', header: '单品实物重(g)', field: 'packageWeight', width: '110px', align: 'right'},
          {id: 'volume', header: '单品体积(CBM)', field: 'volume', width: '115px', align: 'right'},
          {id: 'quantity', header: '调拨量', field: 'quantity', width: '80px', align: 'right'},
          pick ? {id: 'pickQuantity', header: '拣货量', field: 'slot:pickQuantity', width: '120px'} : null,
          {id: 'totalPackageWeight', header: '总实物重(g)', field: 'totalPackageWeight', width: '100px', align: 'right'},
          {id: 'totalVolume', header: '总体积(CBM)', field: 'totalVolume', width: '100px', align: 'right'},
          {id: 'purchaseCost', header: '采购成本',prefix: 'currencySymbol', field: 'purchaseCost', width: '115px', align: 'right'},
          {id: 'arriveCost', header: '到库成本',prefix: 'currencySymbol', field: 'arriveCost', width: '115px', align: 'right'},
          {id: 'totalPurchaseCost', header: '总采购成本',prefix: 'currencySymbol', field: 'totalPurchaseCost', width: '115px', align: 'right'},
          {id: 'totalArriveCost', header: '总到库成本',prefix: 'currencySymbol', field: 'totalArriveCost', width: '115px', align: 'right'},
          showRlInfo ? {id: 'shipmentId', header: '关联货件', field: 'slot:shipmentId', width: '150px'} : null,
          showRlInfo ? {id: 'deliveryCode', header: '关联发货单', field: 'slot:deliveryCode', width: '150px'} : null,
          {id: 'memo', header: '备注', field: 'memo', minWidth: '300px'},
        ].filter(item => isMeaningful(item));
      },
      quantityInput(row) {
        if (isMeaningful(row.quantity) && this.RE.pt.test(row.quantity)) {
          row.totalPackageWeight = toFixed(Number(row.quantity) * Number(row.packageWeight));
          row.totalVolume = toFixed(Number(row.quantity) * Number(row.volume));
        } else {
           row.totalPackageWeight = '-';
           row.totalVolume = '-';
        }
      },
      addProduct() {
        if (!this.canAddProduct()) {
          return;
        }
        this.$gjCreate(AppAddProductModal, {
          mountTo: this.mountTo,
          props: {
            warehouseId: this.form.warehouseId,
            arrivalWarehouseId: this.form.arrivalWarehouseId,
            arrivalMarketId: this.form.arrivalMarketId,
            hideMskuList: this.form.items.map(item => item[this.uniKey])
          },
          on: {
            select: (products) => {
              const items = this.form.items.concat(products.map(item => this.mapToItem(item)));
              this.form.items = unique(items, this.uniKey);
            }
          }
        });
      },
      importProduct() {
        if (!this.canAddProduct()) {
          return;
        }
        this.$gjCreate(AppImportProductModal, {
          mountTo: this.mountTo,
          props: {
            warehouseId: this.form.warehouseId,
            arrivalWarehouseId: this.form.arrivalWarehouseId,
            arrivalMarketId: this.form.arrivalMarketId,
          },
          on: {
            importSuccess: (data) => {
              this.updateItems(data);
            },
            importPartSuccess: (data) => {
              this.updateItems(data);
            }
          }
        })
      },
      updateItems(data) {
        if (isMeaningful(data)) {
          data.forEach(newItem => {
            const find = this.form.items.find(oldItem => newItem[this.uniKey] === oldItem[this.uniKey]);
            if (find) {
              Object.assign(find, this.mapToItem(newItem));
            } else {
              this.form.items.push(this.mapToItem(newItem));
            }
          });
        }
      },
      mapToItem(item) {
        return {
          ...item,
          quantity: item.quantity || null,
          memo: item.memo || null
        }
      },
      canAddProduct() {
        if (isMeaningless(this.form.warehouseId)
          || isMeaningless(this.form.arrivalWarehouseId)
          || isMeaningless(this.form.arrivalMarketId)) {
          this.$gjMessage.error('请先选择调出仓、调入仓、站点');
          return false;
        }
        return true;
      },
      bindShipment() {
        const modal = this.$gjCreate("gj-info-modal", {
          mountTo: this.mountTo,
          props: {
            content: '调拨到FBA仓需审批通过后才能绑定货件',
          },
          on: {
            confirm: () => modal.$gjDestroy()
          },
        });
      },
      formValidate() {
        if (this._.isEmpty(this.form.items)) {
          this.$gjMessage.error('请添加产品');
          return false;
        }
        return this.$gjFormValidate();
      }
    }
  }
</script>

<style lang="scss" scoped>
.content,p,span{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width:200px;
}
/deep/ .gj-table{
  padding-bottom: 1px;
}

/deep/ .gj-table-item .el-form-item__error{
  margin-top:0
}
</style>
